


























import { Component, Prop, Mixins } from "vue-property-decorator";
import { i18n } from "@/i18n";

// Mixins
import { WidgetMixin, IdMixin, EventMixin, FieldMixin, GroupMixin, InputMixin, Validator } from "./mixins";

@Component({
  props: {
    default: { default: undefined }
  }
})
export default class WSelect extends Mixins(
  Mixins(WidgetMixin, IdMixin, EventMixin, FieldMixin),
  GroupMixin,
  InputMixin,
) {

  @Prop({ type: String })
  icon?: string;

  @Prop({ type: Array, required: true })
  options!: any[];

  created() {
    this.labelId = this.uniqueId("__W_SELECT_");
  }

  get computedOptions() {
    return this.options.map(o => ({ text: i18n.t(o.text), value: o.value }));
  }

  @Validator("required")
  requiredValidator(value: any) {
    return !!value;
  }
}
